export default "<state-page-loader *ngIf=\"store.loader$ | async\"></state-page-loader>\r\n<router-outlet></router-outlet>\r\n\r\n";